/* eslint max-len: 0 */
import React, { SVGProps } from "react";

const Router = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.5459 13.7271H7.4541V9.63623H8.5459V13.7271ZM8.5459 2.27295C10.3531 2.27319 11.8182 3.73821 11.8184 5.54541C13.0231 5.54551 13.9998 6.52232 14 7.72705V9.09131C13.9999 10.2961 13.0232 11.2729 11.8184 11.2729H10.7275V10.1821H11.8184C12.4207 10.182 12.909 9.69362 12.9092 9.09131V7.72705C12.909 7.1248 12.4206 6.63633 11.8184 6.63623H10.7275V5.54541C10.7274 4.34069 9.7506 3.36401 8.5459 3.36377H7.4541C6.2494 3.36401 5.27259 4.34069 5.27246 5.54541V7.18213H3.90918C3.45731 7.18213 3.09082 7.54862 3.09082 8.00049V9.36377C3.09082 9.81563 3.45731 10.1821 3.90918 10.1821H5.27246V11.2729H3.90918C2.85482 11.2729 2 10.4181 2 9.36377V8.00049C2 6.94614 2.85482 6.09131 3.90918 6.09131H4.18164V5.54541C4.18177 3.73821 5.64691 2.27319 7.4541 2.27295H8.5459ZM10.5908 8.95459L9.77246 9.77295L8 8.00049L6.22754 9.77295L5.40918 8.95459L8 6.36377L10.5908 8.95459Z"
        fill={props.fill || "#ED0037"}
      />
    </svg>
  );
};

Router.displayName = "Router";

export default Router;
